import { render, staticRenderFns } from "./EmbedHeader.vue?vue&type=template&id=2f9c3aa0&scoped=true"
import script from "./EmbedHeader.vue?vue&type=script&lang=js"
export * from "./EmbedHeader.vue?vue&type=script&lang=js"
import style0 from "./EmbedHeader.css?vue&type=style&index=0&id=2f9c3aa0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c3aa0",
  null
  
)

export default component.exports